import React from "react";
import{ Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import Button from "../CtButton";

export default class ItemModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      register: {
        "title": "",
        "description": "",
        "price": ""
      },
      item: {
        "title": "",
        "description": "",
        "price": ""
      }
    }

    this.registerNotEmpty = this.registerNotEmpty.bind(this);
  }

  registerNotEmpty(e, state) {
    var item = this.state.item;
    var register = this.state.register;
    item[state] = e.target.value;
    this.setState({ register, item });
  }

  formSubmit(e) {
    e.preventDefault()
    var payload = this.state.item
    payload.menu_id = this.props.parentMenu.id
    this.props.onSubmit(payload)
    this.props.toggleModal()
  }

  render() {
    return (
      <Modal isOpen={this.props.modalOpen} toggle={this.props.toggleModal}>
        <Form onSubmit={ e => this.formSubmit(e, this.state.event) }>
          <ModalHeader className="justify-content-center" toggle={this.props.toggleModal}>
            <FormGroup className={this.state.register.title}>
              <Input placeholder="Add Item" className="text-center" onChange={e => this.registerNotEmpty(e, "title")} value={this.state.item.title}/>
            </FormGroup>
          </ModalHeader>
          <ModalBody>
            <FormGroup className={"has-label"}>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>$</InputGroupText>
                </InputGroupAddon>
                <Input type="text" placeholder="Item price" onChange={e => this.registerNotEmpty(e, "price")} value={this.state.item.price}/>
              </InputGroup>
            </FormGroup>
            <FormGroup className={"has-label"}>
              <Input type="textarea" name="text" placeholder="Add description" onChange={e => this.registerNotEmpty(e, "description")} value={this.state.item.description}/>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.props.toggleModal}>
                Close
            </Button>
            <Button color="primary" type="submit">
              Add
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    )
  }
}